import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import cloneDeep from "lodash/cloneDeep";
import Card from "wonderbly-components/lib/Card";
import ProductGridMarketingCard from "../ProductGrid/ProductGridMarketingCard";
import { addMarketingCardCode } from "../ProductGrid/helpers";
import SectionHeading from "../SectionHeading";
import { useModel } from "../../hooks";
import "./SublimatorProductGrid.scss";

const SublimatorProductGrid = (props) => {
  const { sublimatorModel } = useModel();
  if (!sublimatorModel?.products) {
    return null;
  }

  // clone the sublmiator products to stop mutation
  const gridItems = cloneDeep(sublimatorModel.products);

  // add each marketing card, if the grid is too short push them on the end
  for (const [idx, marketingCard] of props.items.entries()) {
    // position first card always at 5
    // every following card at 11, 16, 21
    const position = idx === 0 ? 4 : (idx + 1) * 5 + 1;
    position > gridItems.length
      ? gridItems.push(marketingCard)
      : gridItems.splice(position, 0, marketingCard);
  }

  // Prismic sends productsLimit as a string
  const smallProductGrid = props.productsLimit === "4";

  return (
    <section className="SublimatorProductGrid">
      {props.title && (
        <SectionHeading tag="h2" textAlign="left">
          {props.title}
        </SectionHeading>
      )}
      {props.subtitle && (
        <div className="SublimatorProductGrid__subtitle container-guttered">
          {props.subtitle}
        </div>
      )}
      <div
        className={cx("SublimatorProductGrid__grid container-guttered", {
          "SublimatorProductGrid__sm-product-grid": smallProductGrid,
        })}
      >
        {gridItems.map((gridItem) => {
          if (gridItem.marketingCard) {
            return (
              <div
                className="SublimatorProductGrid__marketing-card"
                key={gridItem.marketingCard.main.uid}
              >
                <ProductGridMarketingCard
                  {...gridItem.marketingCard}
                  {...addMarketingCardCode(gridItem.marketingCard)}
                />
              </div>
            );
          }

          const {
            solidus: { sublimatorAttributes },
            prismic: {
              data: { productListing, productInformation },
            },
            prismicStringReplacements,
          } = gridItem;

          return (
            <Card
              large={!smallProductGrid}
              key={sublimatorAttributes.masterSku}
              href={prismicStringReplacements.href}
              cta={props.cardCtaLabel}
              title={productInformation.title}
              image={productInformation.image.url}
              color={productListing.color}
              imageBackgroundColour="kraft-paper"
              body={productInformation.productBadgeContent}
              ageRange={prismicStringReplacements.ageRange}
              price={prismicStringReplacements.price}
            />
          );
        })}
      </div>
    </section>
  );
};

SublimatorProductGrid.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cardCtaLabel: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  productsLimit: PropTypes.string,
};

export default SublimatorProductGrid;
